module.exports = __webpack_public_path__ + "media/logo.4d194a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/IndexPage/images/logo.png
// module id = qDmY
// module chunks = 1